
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { FormValidationFunction } from "@/views/interfaces/vuetify/form.interface";

@Component({
  mixins: [
    Themeable,
  ],
  inject: [],
})
export default class ServerTypeServicesAdditionDialog extends Vue {
  public visible: boolean = true;
  public newServices: string[] = [];
  public rules: { [key: string]: FormValidationFunction[] } = {
    services: [
      (v: string) => !!v || 'Service name is required!',
    ],
  };

  private selectedDatabaseIdentifier?: number;

  @Prop() public data: {
    serverType: string;
  };

  public async created(): Promise<void> {
  }


  public saveChanges(): void {
    this.$emit('add', JSON.stringify(this.newServices));
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.newServices = [];
    this.$emit('close');
  }
}
